import { Box, Button, Paper, Skeleton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import GoLeftImage from "../../assets/Images/CommonImages/GoLeftImg.png";
import GoRightImage from "../../assets/Images/CommonImages/GoRightImg.png";
import sendEvents from "../../utils/sendEvents";

import "./Carousel.css";
import axios from "axios";

const useStyles = makeStyles(() => ({
  boxContainer: {
    maxWidth: "100%",
    "@media (min-width: 768px)": {
      maxWidth: "calc(100% / 7)",
    },
  },
}));


function CustomRightArrow({ onClick }) {
  function handleClick() {
    onClick();
  }

  return (
    <Button
      onClick={handleClick}
      sx={{
        background: "transparent",
        position: "absolute",
        right: {
          xl: "-15px",
          lg: "-15px",
          md: "-20px",
          sm: "-20px",
          xs: "-20px",
        },
        width: "auto",
        height: "auto",
        border: "none",
        cursor: "pointer",
        padding: "0",
        outline: "none",
        justifyItems: "center",
        alignItems: "center",
        display: "flex",
        alignContent: "center",
        marginTop: "10px",
      }}
      aria-label="Go to next slide"
    >
      <Box
        component={"img"}
        src={GoRightImage}
        alt="GoRightImage"
        sx={{
          width: {
            xl: "40px",
            lg: "40px",
            md: "25px",
            sm: "25px",
            xs: "25px",
          },
        }}
        height={"auto"}
      />
    </Button>
  );
}

function CustomLeftArrow({ onClick }) {
  function handleClick() {
    onClick();
  }

  return (
    <Button
      onClick={handleClick}
      sx={{
        background: "transparent",
        position: "absolute",
        left: {
          xl: "-15px",
          lg: "-15px",
          md: "-20px",
          sm: "-20px",
          xs: "-20px",
        },
        width: "auto",
        height: "auto",
        border: "none",
        cursor: "pointer",
        padding: "0",
        outline: "none",
        justifyItems: "center",
        alignItems: "center",
        display: "flex",
        alignContent: "center",
        marginTop: {
          xl: "10px",
          lg: "10px",
          md: "10px",
          sm: "10px",
          xs: "10px",
        },
      }}
      aria-label="Go to next slide"
    >
      <Box
        component={"img"}
        src={GoLeftImage}
        alt="GoLeftImage"
        sx={{
          width: {
            xl: "40px",
            lg: "40px",
            md: "25px",
            sm: "25px",
            xs: "25px",
          },
        }}
        width={"40px"}
        height={"auto"}
      />
    </Button>
  );
}

const ProductDetailsCarousel = ({ onSendData, all, clear }) => {
  const classes = useStyles();
  const [CompanyTypeData, setCompanyTypeData] = useState([])
  const [categoryId, setcategoryId] = useState("");
  const [categoryIdList, setcategoryIdList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [dataLoading, setdataLoading] = useState(false)

  const getCompanyType = async () => {
    setdataLoading(true)
    await axios
      .get("company_type/get_companyTypes_for_carousel")
      .then((res) => {
        if (res?.data) {
          setCompanyTypeData(res?.data)
          setdataLoading(false)
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {
    getCompanyType();
  }, []);
  window.onload = () => {
    setRefresh(true);
  };
  window.addEventListener("beforeunload", function () { });

  useEffect(() => {
    setcategoryId("")
    setcategoryIdList([])
  }, [all, clear])


  useEffect(() => {
    setcategoryId("")
    setcategoryIdList([])
  }, [clear])

  return (
    <Paper
      sx={{
        width: "100%",
        height: "90%",
        minHeight: "80px",
        zIndex: 1,
        bgcolor: "transparent",
      }}
      elevation={0}
    >
      <Carousel
        additionalTransfrom={0}
        scrollable
        arrows
        autoPlaySpeed={3000}
        centerMode={false}
        className=""
        containerClass="container"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite={false}
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        customLeftArrow={<CustomLeftArrow />}
        customRightArrow={<CustomRightArrow />}
        renderArrowsWhenDisabled={false}
        renderButtonGroupOutside={false}
        renderDotsOutside={false}
        responsive={{
          superLargeDesktop: {
            breakpoint: {
              max: 4000,
              min: 1440,
            },
            items: 7,
            partialVisibilityGutter: 10,
          },

          largeDesktop: {
            breakpoint: {
              max: 2200,
              min: 1440,
            },
            items: 6,
            partialVisibilityGutter: 10,
          },
          desktop: {
            breakpoint: {
              max: 1440,
              min: 768,
            },
            items: 5,
            partialVisibilityGutter: 10,
          },
          tablet: {
            breakpoint: {
              max: 768,
              min: 464,
            },
            items: 3,
            partialVisibilityGutter: 30,
          },
          mobile: {
            breakpoint: {
              max: 464,
              min: 320,
            },
            items: 2,
            partialVisibilityGutter: 30,
          },
        }}
        rewind={false}
        rewindWithAnimation={false}
        rtl={false}
        shouldResetAutoplay
        showDots={false}
        sliderClass=""
        slidesToSlide={1}
        swipeable
      >

        {dataLoading ?
          <Box sx={{
            height: "auto",
            width: "100%",
            maxWidth: "100%",
            minWidth: "100vw",
            display: "flex",
            flexDirection: "row",
            gap: "20px" // Corrected typo
          }}>


            <Skeleton variant="rounded" width={210} height={70} />
            <Skeleton variant="rounded" width={210} height={70} />
            <Skeleton variant="rounded" width={210} height={70} />
            <Skeleton variant="rounded" width={210} height={70} />
            <Skeleton variant="rounded" width={210} height={70} />
            <Skeleton variant="rounded" width={210} height={70} />
            <Skeleton variant="rounded" width={210} height={70} />
            <Skeleton variant="rounded" width={210} height={70} />
            <Skeleton variant="rounded" width={210} height={70} />
            <Skeleton variant="rounded" width={210} height={70} />

          </Box>

          : CompanyTypeData?.length > 0 &&
          CompanyTypeData
            ?.map((item, index) => {
              const displayCompanyTypeName = 
              item.CompanyTypeName === "Airlines Tickets" 
                ? "Airline Tickets" 
                : item.CompanyTypeName;
              return (
                <Box
                  className={classes.boxContainer}
                  onClick={() => {
                    setcategoryId(item._id);
                    setcategoryIdList((prevList) => {
                      const newList = prevList.includes(item._id)
                        ? prevList.filter((id) => id !== item._id)
                        : [...prevList, item._id];
                      onSendData(newList);
                      return newList;
                    });
                  }}
                  key={index}
                  sx={{
                    px: {
                      xl: "5px",
                      lg: "5px",
                      md: "5px",
                      sm: "0px",
                      xs: "0px",
                    },
                    borderRadius: "10px",
                    py: { xl: 1, lg: 1, md: 1, sm: 1.5, xs: 1.5 },
                    width: "auto",
                    display: "flex",
                    gap: {
                      xl: "5px",
                      lg: "5px",
                      md: "5px",
                      sm: "0px",
                      xs: "0px",
                    },
                  }}
                >
                  <Paper
                    onClick={() => {
                      sendEvents("Click on category button on marketplace");
                    }}
                    sx={{
                      ...FilterPaper,
                      border: categoryIdList.includes(item._id)
                        ? "2px solid #445FD2"
                        : "2px solid #FFFFFF",
                      fontFamily: "Poppins",
                      fontStyle: "normal",
                      fontWeight: categoryId !== item._id ? 500 : 600,
                      fontSize: {
                        xl: "13px",
                        lg: "13px",
                        md: "12px",
                        sm: "6px",
                        xs: "6px",
                      },
                      textAlign: "center",
                      mt: 0.5,
                      color: categoryId !== item._id ? "#6F6F6F" : "#445FD2",
                      "&:hover": {
                        border: "2px solid #E0F0FF",
                        cursor: "pointer",
                        color: "#445FD2",
                        fontWeight: 600,
                        background: "#E0F0FF",
                      },
                    }}
                    key={index}
                    elevation={0}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        alignContent: "center",
                      }}
                    >
                      <Box
                        component={"img"}
                        src={item?.Icon}
                        alt="filter"
                        sx={{
                          width: {
                            xl: "35px",
                            lg: "35px",
                            md: "35px",
                            sm: "25px",
                            xs: "25px",
                          },
                          height: "auto",
                        }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "12px",
                        textAlign: "center",
                        color: "#6F6F6F",
                      }}
                    >
                      {displayCompanyTypeName}
                    </Typography>
                  </Paper>
                </Box>
              );
            })}
      </Carousel>
    </Paper>
  );
};

export default ProductDetailsCarousel;

const FilterPaper = {
  background: "#ffffff",
  borderRadius: "20px",
  width: {
    xl: "100%",
    lg: "100%",
    md: "100%",
    sm: "90%",
    xs: "90%",
  },
  minWidth: { xl: "200px", lg: "200px", md: "160px", sm: "130px", xs: "100px" },
  mx: "auto",
  height: "80%",
  minHeight: { xl: "70px", lg: "70px", md: "70px", sm: "60px", xs: "60px" },
  display: "grid",
  justifyContent: "center",
  alignItems: "center",
  alignContent: "center",
  cursor: "pointer",
};
